import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import './app/i18n';
import './shared/styles/global.scss';

// Initialize storage version management
import { initializeStorageVersion } from './utils/storageVersion';

// Import ErrorBoundary
import ErrorBoundary from './shared/components/ErrorBoundary';
import posthog from 'posthog-js';

// Initialize storage version system first (critical for cache compatibility)
initializeStorageVersion();

// PostHog will handle global error tracking automatically via exception autocapture
// This is enabled in the PostHogProvider configuration

// Global error handlers with session recording triggers
window.addEventListener('error', (event) => {
  if (posthog) {
    // Start session recording immediately for error context
    try {
      posthog.startSessionRecording(true); // Force start recording regardless of sampling
    } catch (recordingError) {
      // Session recording failed, but error is already captured above
    }

    // Capture exception with enhanced context
    posthog.captureException(event.error || new Error(event.message), {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error_type: 'window.onerror',
      handler_type: 'global',
      development_mode: import.meta.env.DEV,
      session_recording_triggered: true,
    });
  }
});

// Global handler for unhandled promise rejections with session recording
window.addEventListener('unhandledrejection', (event) => {
  if (posthog) {
    // Start session recording immediately for error context
    try {
      posthog.startSessionRecording(true); // Force start recording regardless of sampling
    } catch (recordingError) {
      // Session recording failed, but error is already captured above
    }

    const error =
      event.reason instanceof Error
        ? event.reason
        : new Error(`Unhandled promise rejection: ${event.reason}`);

    posthog.captureException(error, {
      error_type: 'unhandledrejection',
      promise: event.promise?.toString(),
      handler_type: 'global',
      session_recording_triggered: true,
    });
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary showDetails={import.meta.env.MODE === 'development'}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
